export enum NfApiSituation {
    PROCESSING = "processando_autorizacao", 
    AUTHORIZED = "autorizado", 
    CANCELED = "cancelado", 
    ERROR_AUTHORIZATION = "erro_autorizacao", 
    ERROR_API = "erro_api",
    DENIED = "denegado",
    PROCESSING_TIMEOUT = "tempo_processamento_excedido",
};